/* repo/user*/
import { omit, isEmpty } from "ramda";
import {
  fetch as fetchApi,
  insert as insertApi,
  drop as dropApi,
  isString,
} from "./api";
import { UserCodec, User, Data } from "../store/user/types";
import { withDecoded, flattenData } from "./";
import authenticator from "authenticator";

function mapToModel(data: object): User {
  return withDecoded(UserCodec, data, (decoded) => ({
    ...decoded,
  }));
}

function mapToChageset(user: Data): Data {
  return user;
}

export async function fetch(id: string | null, params?: {}): Promise<User> {
  return fetchApi({
    nestedResourcePath: ["user"],
    id: id,
    params: params,
  }).then((response) =>
    mapToModel(
      flattenData(
        isString(response.data) ? JSON.parse(response.data) : response.data
      )
    )
  );
}

export async function fetchPermission(id: string | null, params?: {}): Promise<User> {
  return fetchApi({
    nestedResourcePath: ["user"],
    id: id,
    params: params,
  }).then((response) =>
    mapToModel(
      flattenData(
        isString(response.data) ? JSON.parse(response.data) : response.data
      )
    )
  );
}

export async function save(user: Data): Promise<User> {
  return insertApi({
    nestedResourcePath: ["user"],
    id: user.id,
    data: { data: mapToChageset(user) },
  }).then((response) =>
    mapToModel(
      flattenData(
        isString(response.data) ? JSON.parse(response.data) : response.data
      )
    )
  );
}

export async function drop(id: string | null): Promise<boolean> {
  return dropApi({
    nestedResourcePath: ["user"],
    id: id,
  }).then(() => true);
}
